import {
  alpha,
  IconButton,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const TableContainerStyled = styled(TableContainer)({
  maxHeight: 600,
  width: '100%',
});

export const TableHeadStyled = styled(TableHead)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
}));

export const TableCellHeaderStyled = styled(TableCell)(({ theme }) => ({
  color: theme.palette.global.white,
  fontWeight: 600,
  backgroundColor: theme.palette.primary.main,
  fontSize: '12px',
}));

export const TableRowStyled = styled(TableRow)(({ theme }) => ({
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: alpha(theme.palette.global.gray, 0.1),
  },
}));

export const IconActionsStyled = styled(IconButton)(({ theme }) => ({
  '&:hover': {
    color: theme.palette.secondary.main,
  },
}));

export const DivNoDataStyled = styled('div')({
  textAlign: 'center',
  padding: '20px 0',
});
